import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import EditLessonForm from './lessonForm';

import * as actions from '../../actions/grammarActivities';
import { GrammarActivity } from '../../interfaces/grammarActivities';
import { GrammarActivityState } from '../../reducers/grammarActivitiesReducer';
import {
  FlagDropdown,
  LinkListItem,
  Modal
} from '../../../Shared/index';

interface LessonsProps {
  dispatch: Function;
  lessons: GrammarActivityState;
}

interface LessonsState {
  lessonFlags: string;
}

class Lessons extends React.Component<LessonsProps, LessonsState> {
  constructor(props: LessonsProps) {
    super(props)

    this.state = {
      lessonFlags: 'All Flags'
    }

    this.handleCreateNew = this.handleCreateNew.bind(this)
    this.submitNewLesson = this.submitNewLesson.bind(this)
    this.renderLessons = this.renderLessons.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleCreateNew() {
    const { dispatch } = this.props;
    dispatch(actions.toggleNewLessonModal());
  }

  submitNewLesson(data: GrammarActivity) {
    const { dispatch } = this.props;
    dispatch(actions.submitNewLesson(data));
  }

  renderLessons() {
    const { lessons } = this.props;
    const { lessonFlags } = this.state;
    const { data, } = lessons;
    let keys = _.keys(data);

    keys = keys.filter((key: string) => !data[key].fill_in_the_blank);

    if (lessonFlags !== 'All Flags') {
      keys = keys.filter((key: string) => data[key].flag === lessonFlags)
    }
    return keys.sort((a, b) => {
      const aTitle = data[a].title
      const bTitle = data[b].title
      if (aTitle && bTitle) {
        return aTitle.localeCompare(bTitle)
      } else {
        return a
      }
    }).map((key: string) => (
      <LinkListItem
        activeClassName='is-active'
        basePath='lessons'
        itemKey={key}
        key={key}
        text={data[key].title || 'No name'}
      />
    ));
  }

  renderModal() {
    const { lessons } = this.props;
    const stateSpecificClass = lessons.submittingnew ? 'is-loading' : '';
    if (lessons.newLessonModalOpen) {
      return (
        <Modal close={this.handleCreateNew}>
          <EditLessonForm stateSpecificClass={stateSpecificClass} submit={this.submitNewLesson} />
        </Modal>
      );
    }
  }

  handleSelect(e) {
    this.setState({ lessonFlags: e.target.value, });
  }

  render() {
    const { lessonFlags } = this.state;
    return (
      <section className="section">
        <div className="container">
          <h1 className="title"><button className="button is-primary" onClick={this.handleCreateNew} type="button">Create New Activity</button></h1>
          { this.renderModal() }
          <div style={{display: 'inline-block'}}>
            <FlagDropdown flag={lessonFlags} handleFlagChange={this.handleSelect} isLessons={true} />
          </div>
          <div className="columns">
            <div className="column">
              <aside className="menu">
                <p className="menu-label">
                  Activities
                </p>
                <ul className="menu-list">
                  {this.renderLessons()}
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </section>

    );
  }
}

function select(state) {
  return {
    lessons: state.grammarActivities,
    questions: state.questions,
  };
}

export default connect(select)(Lessons);
